import i18n from 'i18next';
import {MainErrorType} from "../redux/Main/common";

// Error keys contain dots ("text.too_long"), so they are looked up flat.
const FLAT = {keySeparator: false as const};

const placeholdersOf = (text: string): string[] =>
    Array.from(text.matchAll(/\{\{(\w+)\}\}/g), (match) => match[1]);

const translateKey = (key: string, params: MainErrorType['params'] = {}): string | null => {
    const values = params || {};

    // "Too long, the maximum is 280" only when the backend knew the limit.
    const detailed = i18n.getResource(i18n.language, 'error', key + '.detailed', FLAT)
        ?? i18n.getResource('en', 'error', key + '.detailed', FLAT);
    if (typeof detailed === 'string' && placeholdersOf(detailed).every((name) => values[name] !== undefined && values[name] !== null)) {
        return i18n.t('error:' + key + '.detailed', {...values, ...FLAT});
    }

    if (i18n.exists('error:' + key, FLAT)) {
        return i18n.t('error:' + key, {...values, ...FLAT});
    }

    return null;
};

/**
 * Why something failed, in the reader's language. The server's translation wins when there is one
 * (it also knows keys newer than this build); otherwise the key is translated here, as for
 * websocket pushes, which the server cannot translate.
 */
export const errorMessage = (error: MainErrorType): string => {
    if (error.message) {
        return error.message;
    }
    if (error.key) {
        const translated = translateKey(error.key, error.params);
        if (translated !== null) {
            return translated;
        }
    }

    return i18n.t('error:unknown', FLAT);
};

/**
 * The social network's own words, when they add something to errorMessage().
 */
export const errorDetails = (error: MainErrorType): string | null => {
    const text = (error.text || '').trim();

    return text !== '' && text !== errorMessage(error) ? text : null;
};

export const errorsSummary = (errors?: MainErrorType[] | null): string | null => {
    if (!errors || errors.length === 0) {
        return null;
    }

    return Array.from(new Set(errors.map(errorMessage))).join(' ');
};
